<template>
  <!-- The Modal -->
  <div id="myModal" class="modal-sjq" @click="close">

    <!-- Modal content -->
    <div class="modal-content" @click.stop>
      <slot></slot>

      <div class="modal-footer" style="float: right">
        <slot name="footer"></slot>
        <a href="#!" class="modal-action modal-close waves-effect waves-green btn-flat" @click="close">Fechar</a>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    mounted() {
      document.documentElement.classList.add('hide-scroll');
    },
    destroyed() {
      document.documentElement.classList.remove('hide-scroll');
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  }
</script>

<style scoped>
  /* The Modal (background) */
  .modal-sjq {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 999; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }

  /* Modal Content/Box */
  .modal-sjq .modal-content {
    background-color: #fefefe;
    margin: 100px auto; /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 55%; /* Could be more or less, depending on screen size */
    display: table;
  }

  /* The Close Button */
  .modal-sjq .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .modal-sjq .close:hover,
  .modal-sjq .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/ModalSemJq.vue